import { render, staticRenderFns } from "./TemplateCheckboxField.vue?vue&type=template&id=70fbea63&scoped=true"
import script from "./TemplateCheckboxField.vue?vue&type=script&lang=ts"
export * from "./TemplateCheckboxField.vue?vue&type=script&lang=ts"
import style0 from "./TemplateCheckboxField.vue?vue&type=style&index=0&id=70fbea63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbea63",
  null
  
)

export default component.exports